export default __webpack_public_path__ + "static/media/bg2.00524d03.gif";